import { render, staticRenderFns } from "./BookingComplaints.vue?vue&type=template&id=996b3966&scoped=true"
import script from "./BookingComplaints.vue?vue&type=script&lang=js"
export * from "./BookingComplaints.vue?vue&type=script&lang=js"
import style0 from "./BookingComplaints.vue?vue&type=style&index=0&id=996b3966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996b3966",
  null
  
)

export default component.exports